import { render, staticRenderFns } from "./DailyInsectCountChart.vue?vue&type=template&id=37c1e70b&"
import script from "./DailyInsectCountChart.vue?vue&type=script&lang=js&"
export * from "./DailyInsectCountChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DailyInsectCountChart.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c1e70b')) {
      api.createRecord('37c1e70b', component.options)
    } else {
      api.reload('37c1e70b', component.options)
    }
    module.hot.accept("./DailyInsectCountChart.vue?vue&type=template&id=37c1e70b&", function () {
      api.rerender('37c1e70b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/DailyInsectCountChart/DailyInsectCountChart.vue"
export default component.exports